import styled, { keyframes } from "styled-components";

import { rem } from "@ui/helpers";

import { Size, Padding } from "./LoaderBolt.types";

const rotate = keyframes`
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(540deg);
  }
`;

interface ContainerProps {
  $size: Size;
  $padding: Padding;
}

export const Container = styled.div<ContainerProps>`
  --loader-bolt-size: ${props => rem(props.$size)};
  --loader-bolt-padding: ${({ $padding, theme }) =>
    typeof $padding === "number" ? rem($padding) : theme.spacing[$padding]};

  position: relative;
  padding: var(--loader-bolt-padding);
  display: inline-block;
  pointer-events: none;
`;

export const SVG = styled.svg`
  position: relative;
  width: var(--loader-bolt-size);
  height: var(--loader-bolt-size);
`;

export const Group = styled.g`
  transform: rotate(180deg);
  transform-origin: center center;
  animation: ${rotate} 1000ms infinite cubic-bezier(0.5, 0, 0.15, 1);
`;
